import React from 'react'
import { useTranslation } from 'react-i18next'

import { Accordion, AccordionTab } from 'primereact/accordion'
import { Message } from 'primereact/message'

import { isItemInitial } from '../../../../../utils/helper/checkConfirmationCodes'
import { useAllDeliveryForecastItems } from '../../../data'
import { Position } from './Position'

type Props = {
  deliveryForecastId: string
  isConfirmationActive: boolean
}

export const Divisions: React.FC<Props> = ({
  deliveryForecastId,
  isConfirmationActive,
}) => {
  const { t } = useTranslation()
  const { data: deliveryForecastItems } =
    useAllDeliveryForecastItems(deliveryForecastId)

  const createDynamicTabs = () => {
    const onlyOneItem = deliveryForecastItems?.length === 1

    return deliveryForecastItems?.map(item => {
      return (
        <AccordionTab
          key={item.BuyerProductId}
          header={t(
            'deliveryForecast.title.send.dialog.shedules.positions.title',
            {
              position: item.Position,
            },
          )}
          disabled={onlyOneItem}
        >
          {/* @ts-ignore */}
          <Position deliveryForecastId={deliveryForecastId} id={item.Id} />
        </AccordionTab>
      )
    })
  }

  return (
    <>
      <h3>{t('deliveryForecast.title.send.dialog.shedules.title')}</h3>

      {isItemInitial(deliveryForecastItems) && (
        <Message
          className="mb-3"
          text={
            isConfirmationActive
              ? t(
                  'deliveryForecast.title.send.dialog.shedules.message.withConfirmation',
                )
              : t(
                  'deliveryForecast.title.send.dialog.shedules.message.withoutConfirmation',
                )
          }
        />
      )}

      <Accordion activeIndex={0}>{createDynamicTabs()}</Accordion>
    </>
  )
}
